module.exports = __webpack_public_path__ + "static/media/kadinsky-7.69597172.jpeg";